// Platform detection helpers for Capacitor native vs. web
// Import @capacitor/core lazily so the web build doesn't fail before Capacitor is installed

let _capacitor: any = null;

function getCapacitor() {
  if (_capacitor) return _capacitor;
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    _capacitor = require('@capacitor/core').Capacitor;
  } catch {
    _capacitor = null;
  }
  return _capacitor;
}

export function isNative(): boolean {
  const cap = getCapacitor();
  return cap ? cap.isNativePlatform() : false;
}

export function isIOS(): boolean {
  const cap = getCapacitor();
  return cap ? cap.getPlatform() === 'ios' : false;
}

export function isAndroid(): boolean {
  const cap = getCapacitor();
  return cap ? cap.getPlatform() === 'android' : false;
}

export function isWeb(): boolean {
  return !isNative();
}

export function getPlatform(): 'ios' | 'android' | 'web' {
  const cap = getCapacitor();
  return cap ? cap.getPlatform() : 'web';
}
